<template>
  <v-col cols="12" md="6">
    <BasicButton
      class="basic-button--jangsabot"
      @click="moveToJangsabot"
      header="단골 고객으로 매출 3배 만들기"
    >
      <v-icon left color="#4163d5">mdi-robot</v-icon>
      AI 장사비서 3개월 집중관리
    </BasicButton>
  </v-col>
</template>

<script>
export default {
  name: 'JangsabotBanner',
  components: {
    BasicButton: () => import('@/components/common/button/BasicButton.vue'),
  },
  methods: {
    moveToJangsabot() {
      window.open('https://www.jangsabot.com/', '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.basic-button--jangsabot {
  border: none;
  border-radius: 8px !important;
  position: relative;
  overflow: hidden;
  transition: transform 0.3s ease;
  height: 100%;
  background: linear-gradient(135deg, #2b4ea2, #1a365d) !important;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.1) 50%,
      rgba(255, 255, 255, 0) 100%
    );
    transition: left 0.5s ease;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(75, 121, 228, 0.3) !important;

    &::before {
      left: 100%;
    }
  }

  :deep(.message-container) {
    .header {
      color: rgba(255, 255, 255, 0.9) !important;
      font-size: 0.95rem;
      font-weight: 500;
      margin-bottom: 4px;
    }
    .body {
      font-weight: bold;
      font-size: 1.1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
      color: #ffffff !important;

      .v-icon {
        margin-right: 4px;
      }
    }
  }
}

@media (max-width: 959px) {
  .v-col {
    padding-bottom: 8px;

    &:last-child {
      padding-bottom: 0;
    }
  }
}
</style>
